import { render, staticRenderFns } from "./BestBuysNowStats.vue?vue&type=template&id=7453da5d&scoped=true"
import script from "./BestBuysNowStats.vue?vue&type=script&lang=js"
export * from "./BestBuysNowStats.vue?vue&type=script&lang=js"
import style0 from "./BestBuysNowStats.vue?vue&type=style&index=0&id=7453da5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7453da5d",
  null
  
)

export default component.exports